import PropTypes from 'prop-types';
import { color as themeColor } from '../../../app/theme';

function IconEnter({ className, backgroundColor }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.486 15.643a.648.648 0 0 1 0-.916l2.134-2.134H7.407a3.24 3.24 0 0 1-3.24-3.241V4.815a.648.648 0 0 1 1.296 0v4.537c0 1.074.87 1.944 1.944 1.944h6.213l-2.134-2.134a.648.648 0 0 1 .917-.917l3.24 3.241a.645.645 0 0 1 0 .917l-3.24 3.24a.648.648 0 0 1-.917 0z"
        fill={backgroundColor}
      />
    </svg>
  );
}

IconEnter.defaultProps = {
  className: undefined,
  backgroundColor: themeColor.$15,
};

IconEnter.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default IconEnter;
